'use strict';

angular.module('dekky.forms.fileUploadFilters', [])
.service('fileUploadFilters', function() {
	return {
		fileType: function() {
			var types = '';

			if (arguments.length > 0) {
				for (var i = 0; i < arguments.length; i++) {
					types += arguments[i] + (i+1 < arguments.length ? '|' : '');
				}
			} else {
				types = 'jpg|jpeg|doc|docx|pdf|txt|xls|xlsx'; // Значения по-умолчанию
			}

			var regex = new RegExp( '\.(' + types + ')$'),
				message = 'Разрешена загрузка только файлов следующих типов: ' +  types.split('|').join(', ');

			return {
				name: 'fileType',
				message: message,
				fn: function(item) {
					return regex.test(item.name.toLowerCase());
				}
			}
		},

		fileSize: function(size) {
			var sizeUnit = 'Мб.',
				sizeMessage;
			size = angular.isDefined(size) ? size : (25 * 1024 * 1024); // По-умолчанию 25 мб.
			sizeMessage = Math.floor(size / 1000000);

			if (size < 1000000) {
				sizeUnit = 'Кб.';
				sizeMessage = Math.floor(size / 1000);
			}

			return {
				name: 'fileSize',
				message: 'Разрешена загрузка файлов размером не больше ' + sizeMessage + ' ' + sizeUnit,
				fn: function(item) {
					return size ? item.size <= size : true;
				}
			}
		}
	}
});
